import React, {useEffect, useRef, useState} from "react";
import {Form} from "react-bootstrap";
import {DynamicComponentProps} from "../../core/_models";
import axios from "../../../../helpers/axios";
import { Http } from "../../../../helpers/http";

export function LogViewerComponent({config}: DynamicComponentProps) {
    const {data: value, rows, key, reload, vector} = config;
    const [loading, setLoading] = useState(false);
    const [v, setValue] = useState(value);
    const [shouldScroll, setShouldScroll] = useState(true);

    const textArea = useRef<HTMLTextAreaElement | null>(null);

    const loadForm = async () => {
        setLoading(true);
        try {
            const {data: {data: responseData}} = await Http.post<any>('get_inc_data', {
                key
            })

            if (responseData != null) {
                const data = vector === 'reverse' ? "\n" + responseData : responseData + "\n";
                setValue(vector === 'reverse' ? v + data : data + v);
            }
        } catch (e) {
        } finally {
            setLoading(false);

        }
    }

    const hasReload = reload != null && reload > 0;

    let timer: ReturnType<typeof setTimeout> | null = null;

    const startTimer = () => {
        if (hasReload) {
            if (timer != null) {
                clearTimeout(timer)
            }
            timer = null;
            timer = setTimeout(() => {
                if (!loading) {
                    loadForm();
                }
            }, reload);
        }
    }

    useEffect(() => {
        if (vector === 'reverse' && shouldScroll) {
            const area = ((textArea.current as unknown) as HTMLTextAreaElement);
            area.scrollTop = area.scrollHeight;
        }
        startTimer();
        return () => {
            if (timer != null) {
                clearTimeout(timer)
            }
        };
    });

    return (
        <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>Log View</Form.Label>
            <textarea
                readOnly={true} className={'form-control'} ref={textArea} rows={rows ?? 10}
                onFocus={(e) => setShouldScroll(false)}
                onBlur={(e) => setShouldScroll(true)}
                value={v}
            />
        </Form.Group>
    )
}